import { TRecommendation } from '../../types/recommendation';

export function selectIsChatEnabled(offer: TRecommendation | null): boolean {
  return offer?.author?.isChatsEnabled || false;
}
